module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-LightItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-LightItalic.woff
// module id = 1904
// module chunks = 0